<template>
	<div :class="{'has-error': mensagemErro}">
		<label> <span v-if="obrigatorio" class="no-print">*</span> {{ label }}: </label>
		<date-picker
			class="datepicker-input form-control-datepicker"
			value-type="YYYY-MM-DD"
			:format="_formatDate"
			:value="value.model"
			@input="(value) => emitValue('input', value)"
			:disabled="disabled"
		></date-picker>
		<!-- <input class="form-control" type="date" :value="value" @input="emitValue('input', $event.target.value)" /> -->
		<p class="help-block" v-show="mensagemErro">{{ mensagemErro }}</p>
	</div>
</template>

<script>
import mixinInputModel from './mixinInputModel'
export default {
	mixins: [mixinInputModel]
}
</script>
